import crud_actions from './crud_actions'

export const loadReactions = crud_actions.read('reactions', 'loadReactions')
export const updateReaction = crud_actions.update('reactions', 'updateReaction')
